import React, { useState } from 'react';
import { createTicket } from '../../../api/ticketApi';
import '../../../styles/tickets.css';

const SEVERITY_OPTIONS = [
  '1 - System Down',
  '2 - Significant Impact',
  '3 - Minor Impact',
  '4 - Informational Only',
];

const TYPE_OPTIONS = [
  'Technical Issues',
  'Billing and Payments',
  'Product Inquiries',
  'Feedback',
  'Others',
];

function SupportTicketModal({ orgId, currentUser, onClose }) {
  const [loading,   setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    ticketHeader:      '',
    ticketDescription: '',
    ticketSeverity:    '3 - Minor Impact',
    ticketType:        'Technical Issues',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.ticketHeader.trim() || !form.ticketDescription.trim()) return;
    try {
      setLoading(true);
      await createTicket({
        orgId,
        clientEmail: currentUser?.email || '',
        senderName:  currentUser?.displayName || currentUser?.name || currentUser?.email || 'Admin',
        ...form,
      });
      setSubmitted(true);
    } catch (err) {
      console.error('Error creating ticket:', err);
      alert('Failed to submit ticket. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bb-ticket-overlay" onClick={onClose}>
      <div className="bb-ticket-modal" onClick={e => e.stopPropagation()}>
        <div className="bb-ticket-modal-header">
          <h2>Submit a Support Ticket</h2>
          <button className="bb-ticket-modal-close" onClick={onClose}>&times;</button>
        </div>

        {submitted ? (
          <div className="bb-ticket-confirmation">
            <h3>Ticket Submitted Successfully</h3>
            <p>Your support ticket has been created and our team has been notified.</p>
            <p>We aim to respond to all tickets within 24 hours during business days.</p>
            <p>You can track the status of your ticket by clicking "View my tickets" on this page.</p>
            <button className="bb-ticket-btn-primary" onClick={onClose}>Close</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="bb-ticket-modal-body">
              <div className="bb-ticket-field">
                <label>Organisation ID</label>
                <input type="text" value={orgId} readOnly />
              </div>

              <div className="bb-ticket-field">
                <label>Contact Email</label>
                <input type="text" value={currentUser?.email || ''} readOnly />
              </div>

              <div className="bb-ticket-field">
                <label>Ticket Header *</label>
                <input
                  type="text"
                  name="ticketHeader"
                  value={form.ticketHeader}
                  onChange={handleChange}
                  placeholder="Brief summary of your issue"
                  required
                />
              </div>

              <div className="bb-ticket-field">
                <label>Description *</label>
                <textarea
                  name="ticketDescription"
                  value={form.ticketDescription}
                  onChange={handleChange}
                  placeholder="Describe your issue in detail…"
                  required
                />
              </div>

              <div className="bb-ticket-field">
                <label>Severity</label>
                <select name="ticketSeverity" value={form.ticketSeverity} onChange={handleChange}>
                  {SEVERITY_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              </div>

              <div className="bb-ticket-field">
                <label>Type</label>
                <select name="ticketType" value={form.ticketType} onChange={handleChange}>
                  {TYPE_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              </div>
            </div>

            <div className="bb-ticket-modal-actions">
              <button type="button" className="bb-ticket-btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="bb-ticket-btn-primary" disabled={loading}>
                {loading ? 'Submitting…' : 'Submit Ticket'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default SupportTicketModal;
